import { render } from "./Wild.vue?vue&type=template&id=77789222&scoped=true"
import script from "./Wild.vue?vue&type=script&lang=js"
export * from "./Wild.vue?vue&type=script&lang=js"

import "./Wild.vue?vue&type=style&index=0&id=77789222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77789222"]])

export default __exports__